import { createSlice } from '@reduxjs/toolkit';

const savedTab = localStorage.getItem('active_tab');

const initialState = {
  activeTab: savedTab || 'dashboard',
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setActiveTab(state, action) {
      state.activeTab = action.payload;
      localStorage.setItem('active_tab', action.payload);
    },
    setCreateTaskData(state, action) {
      state.createTaskData = action.payload;
    },
    clearCreateTaskData(state) {
      state.createTaskData = undefined;
    },
  },
});

export const { setActiveTab, setCreateTaskData, clearCreateTaskData } = navigationSlice.actions;
export default navigationSlice.reducer;
